const env = import.meta.env;

export const APIPROXY_HOST = env.VITE_APIPROXY_HOST;
export const STATICDATA_HOST = env.VITE_STATICDATA_HOST;
export const ENV_NAME = env.VITE_ENV_NAME;
export const APP_VERSION = env.VITE_APP_VERSION;
export const CONTENTFUL_SPACE = env.VITE_CONTENTFUL_SPACE;
export const CONTENTFUL_PREVIEWTOKEN = env.VITE_CONTENTFUL_PREVIEWTOKEN;
export const CONTENTFUL_READTOKEN = env.VITE_CONTENTFUL_READTOKEN;
export const CONTENTFUL_ENV = env.VITE_CONTENTFUL_ENV;
export const TAGMANAGERID = env.VITE_TAGMANAGERID;
export const NEWRELIC_APP_ID = env.VITE_NEWRELIC_APP_ID;
export const NEWRELIC_BROWSER_KEY = env.VITE_NEWRELIC_BROWSER_KEY;
export const NEWRELIC_ACCOUNT_ID = env.VITE_NEWRELIC_ACCOUNT_ID;
export const THEME_NAME = env.VITE_THEME_NAME;
export const CONFIG_CAT_KEY = env.VITE_CONFIG_CAT_KEY;
export const SOLIDUM_POSTTOKEN = env.VITE_SOLIDUM_POSTTOKEN;
export const SOLIDUM_POSTFORM = env.VITE_SOLIDUM_POSTFORM;
export const DYNAMICS_INGESTION_KEY = env.VITE_DYNAMICS_INGESTION_KEY;
export const ALGOLIA_SEARCH_KEY = env.VITE_ALGOLIA_SEARCH_KEY || "";
export const ALGOLIA_EXPLAINERS_KEY = env.VITE_ALGOLIA_EXPLAINERS_KEY || "";
export const NODE_ENV = env.PROD ? "production" : "development";
export const MOCK_ENABLED = env.VITE_MOCK_ENABLED === "true";
export const MOCK_CUSTOMER_NUMBER = env.VITE_MOCK_CUSTOMER_NUMBER || "871738";
export const POSTHOG_API_KEY = env.VITE_POSTHOG_API_KEY || "";
export const POSTHOG_ENABLED = POSTHOG_API_KEY !== "" && POSTHOG_API_KEY !== "not-in-use";
export const IS_LOCAL_RUN = APP_VERSION === "local-dev";
